import httpAuth from "../../services/httpAuth";
import getErrorMessage from "../../helpers/getErrorMessage.helper";
import { getCasinoLiveError, getCasinoLiveSuccess } from "./casinoLive.slice";
import { OPERATORID, USERID } from "../../config/app.config";

export const requestCasinoStart =
  (gameId = "", tableId = "") =>
  async (dispatch, getState) => {
    try {
      const checkAuth = getState().auth;
      if (checkAuth) {
        if (gameId === "98789") {
          const response = await httpAuth.post(`/lotus/lobbyUrl`);
          if (response.data.status) {
            dispatch(getCasinoLiveSuccess({ url: response.data?.launchUrl }));
          }
          return response;
        } else if (gameId === "70011") {
          const userId = localStorage.getItem(USERID);
          const operatorId = localStorage.getItem(OPERATORID);
          let url = `https://games.fawk.app/${userId}/${operatorId}/${gameId}`;

          let data = {
            url: url,
            status: true,
            msg: "Play Game.",
          };
          dispatch(getCasinoLiveSuccess({ url: url }));
          return { data };
        }
        const response = await httpAuth.post("qtech/launchUrl", {
          gameId: gameId,
          providerCode: tableId,
        });

        // console.log("casino Res: ", response);
        if (response?.status == 200) {
          if (response?.data?.status) {
            dispatch(getCasinoLiveSuccess(response?.data?.data));
          } else {
            dispatch(getCasinoLiveError());
          }
        } else {
          dispatch(getCasinoLiveError());
        }
        return response;
      }
    } catch (e) {
      dispatch(getCasinoLiveError());
    }
  };

function makeId(length) {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

export const requestCasinoEnd = () => async (dispatch) => {
  dispatch(getCasinoLiveSuccess(null));
};

export const requestLotusStart =
  (gameId = "", tableId = "") =>
  async (dispatch, getState) => {
    try {
      const checkAuth = getState().auth;
      if (checkAuth) {
        // if (gameId === "98789") {
        const response = await httpAuth.post(`/lotus/lobbyUrl`, {
          game_id: gameId,
          game_type: "old",
        });
        if (response.data.status) {
          dispatch(getCasinoLiveSuccess({ url: response.data?.launchUrl }));
        }
        return response;
        // } else if (gameId === "70011") {
        //   const userId = localStorage.getItem(USERID);
        //   const operatorId = localStorage.getItem(OPERATORID);
        //   let url = `https://games.fawk.app/${userId}/${operatorId}/${gameId}`;

        //   let data = {
        //     url: url,
        //     status: true,
        //     msg: "Play Game.",
        //   };
        //   dispatch(getCasinoLiveSuccess({ url: url }));
        //   return { data };
        // }
      }
    } catch (e) {
      dispatch(getCasinoLiveError());
    }
  };
